window.whenSwiperReady = (function () {
  let ready = false;
  let queue = [];
  let checks = 0;
  const maxChecks = 40;
  const checkDelay = 250;

  function flush() {
    ready = true;
    queue.forEach(cb => cb());
    queue.length = 0;
  }

  if (window.Swiper) {
    ready = true;
  } else {
    const check = () => {
      if (window.Swiper) {
        flush();
        return;
      }

      checks += 1;
      if (checks < maxChecks) {
        setTimeout(check, checkDelay);
      }
    };
 
    window.addEventListener('theme:swiper-ready', flush, { once: true });
    check();
  }

  return function (callback) {
    if (ready) {
      callback();
    } else {
      queue.push(callback);
    }
  };
})();

function lazyInit(element, callback) {
  const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      observer.disconnect();
      callback();
    }
  }, { rootMargin: '150px' });

  observer.observe(element);
}

window.whenLenisReady = (function () {
  let ready = false;
  let queue = [];
  let checks = 0;
  const maxChecks = 40;
  const checkDelay = 250;

  function run(fn) {
    if (typeof fn === 'function') {
      fn(window.lenis);
    }
  }

  function flush() {
    ready = true;
    queue.forEach(run);
    queue.length = 0;
  }

  if (window.lenis) {
    ready = true;
  } else {
    const check = () => {
      if (window.lenis) {
        flush();
        return;
      }

      checks += 1;
      if (checks < maxChecks) {
        setTimeout(check, checkDelay);
      }
    };

    window.addEventListener('theme:lenis-ready', flush, { once: true });
    check();
  }

  return function (callback) {
    if (typeof callback !== 'function') return;

    if (ready) {
      run(callback);
    } else {
      queue.push(callback);
    }
  };
})();


var Shopify = Shopify || {};
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = ""; 
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class HeaderElement extends HTMLElement {
  constructor() {
    super();
    this.lastHeight = 0;
    this.update = this.update.bind(this);
  }

  connectedCallback() {
  if (window.innerWidth <= 1100) return;

  this.headerOuter = this.querySelector('.header-outer');
  if (!this.headerOuter) return;

  this.cleanup = rafResizeObserver(this.headerOuter, height => {
    document.body.style.setProperty('--header-height', `${height}px`);
  });
}

disconnectedCallback() {
  this.cleanup?.();
}


  update() {
    if (!this.headerOuter) return;

    const newHeight = this.headerOuter.getBoundingClientRect().height;

    if (newHeight !== this.lastHeight) {
      this.lastHeight = newHeight;
      document.body.style.setProperty('--header-height', `${newHeight}px`);
    }
  }
} 

if (!customElements.get('header-block')) {
  customElements.define('header-block', HeaderElement);
}

function rafResizeObserver(el, onChange) {
  if (!el) return;

  let last = 0;
  let rafId = null;

  const ro = new ResizeObserver(entries => {
    const height = entries[0].contentRect.height;

    if (height === last) return;
    last = height;

    cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      onChange(height);
    });
  });

  ro.observe(el);

  return () => ro.disconnect();
}


class HeroSlideshow extends HTMLElement {
  constructor() {
    super();
 
    this.swiper = null; 
    this._initialized = false; 

    this.sectionId = this.dataset.sectionId || "";
    this.spacing = Number(this.dataset.spacing) || 0;
    this.autoplay = this.dataset.autoplay === "true";
    this.speed = Number(this.dataset.autoplaySpeed) * 1000 || 3000;
    this.effect = this.dataset.effect || "slide";
    this.currentProgress = 0;
    this.handleSectionLoad = this.handleSectionLoad.bind(this);
  }

  connectedCallback() {
    this.getElements();

    if (!this.slider) return;

    window.whenSwiperReady(() => {
      this.initIfReady();
    });

    document.addEventListener("shopify:section:load", this.handleSectionLoad);
  }

  disconnectedCallback() {
    this.destroy();
    document.removeEventListener("shopify:section:load", this.handleSectionLoad);
  }

  getElements() {
    this.slider = this.querySelector(
      `.slideshow-swipe__slider--${this.sectionId}`
    );

    this.nextBtn = this.querySelector(
      `.slideshow-swipe__next--${this.sectionId}`
    );

    this.prevBtn = this.querySelector(
      `.slideshow-swipe__prev--${this.sectionId}`
    );

    this.paginationEl = this.querySelector(
      `.swiper-pagination--${this.sectionId}`
    );

    this.customPagination = this.querySelector(".custom-pagination");
  }

  initIfReady() {
    if (this._initialized) return;
    if (!window.Swiper || !this.slider) return;

    this.init();
    this._initialized = true;
  }

  init() {
    this.getElements();

    if (this.slider?.swiper) {
      this.slider.swiper.destroy(true, true);
    }

    this.swiper = new Swiper(this.slider, {
      slidesPerView: 1,
      spaceBetween: this.spacing,
      speed: 1000,
      effect: this.effect,

      autoplay: this.autoplay
        ? {
            delay: this.speed,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }
        : undefined,

      navigation:
        this.nextBtn && this.prevBtn
          ? {
              nextEl: this.nextBtn,
              prevEl: this.prevBtn,
            }
          : undefined,
       pagination:
        this.paginationEl
          ? {
              el: this.paginationEl,
              clickable: true,
            }
          : undefined,     
      observer: true,
      observeParents: true,

      a11y: {
        enabled: true,
      },
    });

    this.initCustomPagination();
    this.bindEvents();
  }

  /* ================= CUSTOM PAGINATION ================= */

  initCustomPagination() {
    if (!this.customPagination || !this.slider) return;

    this.currentEl = this.customPagination.querySelector(".current");
    this.totalEl = this.customPagination.querySelector(".total");
    this.lineFill = this.customPagination.querySelector(".line-fill");

    // Accurate slide count
    this.totalSlides = this.slider.querySelectorAll(".swiper-slide").length;

    if (this.totalEl) {
      this.totalEl.textContent = this.formatNumber(this.totalSlides);
    }

    // Reset fill
    if (this.lineFill) {
      this.lineFill.style.transform = "scaleY(0)";
    }

    this.updateCustomPagination();
  }

  updateCustomPagination() {
  if (!this.swiper || !this.currentEl) return;

  const current = this.swiper.realIndex + 1;

  this.currentEl.textContent = this.formatNumber(current);

  if (this.lineFill && this.totalSlides) {
    const newProgress = current / this.totalSlides;

    // Smooth animation from previous → new
    this.lineFill.style.transition = "transform 0.6s ease";

    requestAnimationFrame(() => {
      this.lineFill.style.transform = `scaleY(${newProgress})`;
    });

    this.currentProgress = newProgress;
    }
  }

  bindEvents() {
    if (!this.swiper) return;

    this.swiper.on("slideChange", () => {
      this.updateCustomPagination();
    });
  }

  formatNumber(num) {
    return num < 10 ? `0${num}` : num;
  }

  /* ================= DESTROY ================= */

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    this._initialized = false;
  }

  handleSectionLoad(e) {
    if (!this.contains(e.target)) return;

    this.destroy();
    this.initIfReady();
  }
}

if (!customElements.get("slideshow-swipe")) {
  customElements.define("slideshow-swipe", HeroSlideshow);
}


class CollectionList extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this._initialized = false;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    // Use global Swiper defer (REQUIRED)
    window.whenSwiperReady(() => {
      this.initSwiper();
    });
  }

  initSwiper() {
    const styles = getComputedStyle(this);

    let desktopColumns = styles.getPropertyValue('--desktop-column').trim();
    let mobileColumns = styles.getPropertyValue('--mobile-column').trim();
    let gridGap = styles.getPropertyValue('--grid-gap').trim();

    const toNumber = (val, fallback) => {
      if (!val) return fallback;
      const num = parseFloat(val.replace(/[^0-9.-]/g, ''));
      return Number.isFinite(num) ? num : fallback;
    };

    desktopColumns = toNumber(desktopColumns, 3);
    mobileColumns = toNumber(mobileColumns, 1);
    gridGap = toNumber(gridGap, 20);

    const swiperEl = this.querySelector('.swiper');
    if (!swiperEl || swiperEl.swiper) return;

    this.swiper = new Swiper(swiperEl, {
      slidesPerView: desktopColumns,
      spaceBetween: gridGap,

      breakpoints: {
        0: { slidesPerView: mobileColumns },
        500: { slidesPerView: 2 },
        750: { slidesPerView: 4 },
        1250: { slidesPerView: desktopColumns },
      },

      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },

      pagination: {
        el: this.querySelector('.swiper-pagination'),
        type: 'progressbar',
      },

      observer: true,
      observeParents: true,
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    this._initialized = false;
  }
}

customElements.define('collection-list', CollectionList);


class FeaturedCollection extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this._initialized = false;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    window.whenSwiperReady(() => {
      this.init();
    });
  }

  init() {
    const sliderEl = this.querySelector('.swiper');
    if (!sliderEl || sliderEl.swiper) return;

    const wrapper = sliderEl.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    const slides = wrapper.querySelectorAll('.swiper-slide');
    if (slides.length <= 1) return;

    const desktop = parseInt(this.dataset.columns, 10) || 4;
    const mobile = parseFloat(this.dataset.mobColumns, 10) || 2;
    const smallDesktop = parseInt(this.dataset.smallcolumns, 10) || 2;
    const spacing = parseInt(this.dataset.spacing, 10) || 20;

    let nextBtn = this.querySelector('.swiper-button-next');
    let prevBtn = this.querySelector('.swiper-button-prev');

    if (!nextBtn || !prevBtn) {
      nextBtn = document.createElement('div');
      prevBtn = document.createElement('div');

      nextBtn.className = 'slider_button swiper-button-next';
      prevBtn.className = 'slider_button swiper-button-prev';

      this.appendChild(prevBtn);
      this.appendChild(nextBtn);
    }

    this.swiper = new Swiper(sliderEl, {
      slidesPerView: mobile,
      speed: 800,
      spaceBetween: 10,
      loop: false,

      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },

      scrollbar: {
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true,
        snapOnRelease: true,
      },

      breakpoints: {
         640: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        900: {
          slidesPerView: smallDesktop,
          spaceBetween: spacing,
        },
        1300: {
          slidesPerView: desktop,
          spaceBetween: spacing,
        },
      },

      observer: true,
      observeParents: true,
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    this._initialized = false;
  }
}

customElements.define('featured-collection', FeaturedCollection);


class ProductBlock extends HTMLElement {
  constructor() {
    super();
    this.slideGroups = [];
    this.colorOptions = [...this.querySelectorAll('.color_input')];
    this.mainLink = this.querySelector('[data-main-link]');
    this._initialized = false;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    window.whenSwiperReady(() => {
      this.initImageSliders();
      this.bindColorSwatches();
      this.enableKeyboardVisualFocus();
    });
  }

  initImageSliders() {
    const sliderContainers = [
      ...this.querySelectorAll('.product_block_img.swiper')
    ];
    if (!sliderContainers.length) return;

    sliderContainers.forEach(container => {
      if (container.swiper) return;

      const swiperInstance = new Swiper(container, {
        speed: 600,
        slidesPerView: 1,
        spaceBetween: 0,
        a11y: false,
        navigation: {
          nextEl: container.querySelector('.next-button-product-block'),
          prevEl: container.querySelector('.prev-button-product-block'),
        },
        breakpoints: {
          0: { allowTouchMove: true },
          990: { allowTouchMove: false }
        }
      });

      this.slideGroups.push(swiperInstance);
    });
  }

  bindColorSwatches() {
    if (!this.colorOptions.length) return;

    this.colorOptions.forEach(option => {
      option.addEventListener('click', () => {
        const targetImage = option.dataset.variantImage;
        if (!targetImage) return;

        this.slideGroups.forEach(swiper => {
          const index = [...swiper.slides].findIndex(
            slide => slide.dataset.src === targetImage
          );
          if (index !== -1) swiper.slideTo(index);
        });
      });
    });
  }

  enableKeyboardVisualFocus() {
    if (!this.mainLink || !this.colorOptions.length) return;

    this.mainLink.addEventListener('focusin', e => {
      if (!e.target.matches(':focus-visible')) return;
      this.colorOptions.forEach(opt => {
        opt.style.visibility = 'visible';
      });
    });
  }

  disconnectedCallback() {
    this.slideGroups.forEach(swiper => swiper?.destroy(true, true));
    this.slideGroups = [];
    this._initialized = false;
  }
}

customElements.define('product-block', ProductBlock);

 


// Lenis hook placeholder removed to avoid no-op work on every scroll.


class ShopTheLook extends HTMLElement {
  connectedCallback() {
    this.hotspots = this.querySelectorAll('.stl-hotspot');
    this.products = this.querySelectorAll('.stl-product');
    this.wrapper = this.querySelector('.stl-products-swiper');
    this.activeIndex = 0;

    this.initSlider();
    this.onResize = this.onResize || this.debounce(() => this.initSlider(), 150);
    window.addEventListener('resize', this.onResize, { passive: true });

    this.hotspots.forEach((h) => {
      h.setAttribute('role', 'button');
      const button = h.querySelector('button');

      button.addEventListener('click', () => {
        const index = Number(h.dataset.index);
        this.activate(index);
        if (this.slider) this.slider.slideTo(index);
      });

      button.addEventListener('mouseenter', () => this.hoverShow(h.dataset.index));
      button.addEventListener('mouseleave', (e) => this.hoverClear(e));
      button.addEventListener('focusin', () => this.hoverShow(h.dataset.index));
      button.addEventListener('focusout', (e) => this.hoverClear(e));
    });

    this.products.forEach((p) => {
      p.setAttribute('role', 'button');
      p.setAttribute('tabindex', '0');

      p.addEventListener('click', () => {
        const index = Number(p.dataset.index);
        this.activate(index);
        if (this.slider) this.slider.slideTo(index);
      });

      p.addEventListener('mouseenter', () => this.hoverShow(p.dataset.index, true));
      p.addEventListener('mouseleave', (e) => this.hoverClear(e));

      p.addEventListener('focusin', () => this.hoverShow(p.dataset.index, true));
      p.addEventListener('focusout', (e) => this.hoverClear(e));
    });  

    this.activate(0); 
  }

  initSlider() {
    if (!this.wrapper) return;

    if (typeof Swiper === 'undefined') {
      window.whenSwiperReady(() => this.initSlider());
      return;
    }

    if (this.slider) return;
    const isStyle2 = this.classList.contains('hotspot-style-2');
    this.slider = new Swiper(this.wrapper, {
      direction: 'horizontal',
      slidesPerView: 1.2,
      spaceBetween: 16,
      autoHeight: false,
      freeMode: false,
      speed: 800,
      observer: true,
      observeParents: true,
      on: {
        slideChange: () => {
          this.activate(this.slider.realIndex);
        },
      },
      //   breakpoints: {
      //   0: { slidesPerView: 1.5 },
      //   500: { slidesPerView: 2.5 },
      //   750: { slidesPerView: 3 },
      //   1000: { slidesPerView: 4 },
      //   1250: { slidesPerView: 5 },
      // },
      breakpoints: isStyle2
  ? {
      0: {
        slidesPerView: 1.5
      },
      500: {
        slidesPerView: 2.5
      },
      768: {
        slidesPerView: 1
      }
    }
  : {
      0: {
        slidesPerView: 1.5
      },
      500: {
        slidesPerView: 2.5
      },
      750: {
        slidesPerView: 3
      },
      1000: {
        slidesPerView: 4
      },
      1250: {
        slidesPerView: 5
      }
    },
    });
    }


  activate(index) {
    this.activeIndex = index;

    this.products.forEach((p) => p.classList.remove('active'));
    this.hotspots.forEach((h) => h.classList.remove('glow'));

    this.querySelector(`.stl-product[data-index="${index}"]`)?.classList.add('active');
    this.querySelector(`.stl-hotspot[data-index="${index}"]`)?.classList.add('glow');
  }

  hoverShow(index, isProductBlock = false) {
    if (isProductBlock) {
      this.products.forEach((p) => p.classList.remove('active'));
      this.querySelector(`.stl-product[data-index="${index}"]`)?.classList.add('active');
    }

    this.hotspots.forEach((h) => h.classList.remove('glow'));
    this.querySelector(`.stl-hotspot[data-index="${index}"]`)?.classList.add('glow');
  }

  debounce(fn, wait = 100) {
    let timer = null;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  hoverClear(event) {
    const related = event.relatedTarget;

    if (related && this.contains(related)) return;

    this.products.forEach((p) => p.classList.remove('active'));
    this.querySelector(`.stl-product[data-index="${this.activeIndex}"]`)?.classList.add('active');

    this.hotspots.forEach((h) => h.classList.remove('glow'));
    this.querySelector(`.stl-hotspot[data-index="${this.activeIndex}"]`)?.classList.add('glow');
  }

  disconnectedCallback() {
    if (this.onResize) {
      window.removeEventListener('resize', this.onResize);
    }
    this.slider?.destroy(true, true);
    this.slider = null;
  }
}

customElements.define('shop-the-look', ShopTheLook);

class FeaturedBlog extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this._initialized = false;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    lazyInit(this, () => {
    window.whenSwiperReady(() => this.init());
  });
  }

  init() {
    const slides = this.querySelectorAll('.featured_article.swiper-slide');
    if (slides.length <= 1) return;

    const slider = this.querySelector('.featured_block_inner');
    if (!slider) return;

    const spacing = Number(this.dataset.spacing) || 0;

    const navWrapper = this.previousElementSibling;
    const prevBtn = navWrapper?.querySelector('.swiper-button-prev');
    const nextBtn = navWrapper?.querySelector('.swiper-button-next');

    this.swiper = new Swiper(slider, {
      speed: 600,
      slidesPerView: 2,
      spaceBetween: spacing,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: spacing,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: spacing,
        },
        991: {
          slidesPerView: 2,
          spaceBetween: spacing,
        },
        1250: {
          slidesPerView: 3,
          spaceBetween: spacing,
        },
      },
      observer: true,
      observeParents: true,
    });
  }

  disconnectedCallback() {
    this.swiper?.destroy(true, true);
    this.swiper = null;
    this._initialized = false;
  }
}

customElements.define('featured-blog', FeaturedBlog);
 

class TestimonialSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this._initialized = false;
    this._resizeTimer = null;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    const sliderEl = this.querySelector(".testimonial-swiper");
    if (!sliderEl) return;

    window.whenSwiperReady(() => this.init());

    // Recalculate after full page load (images, fonts etc.)
    window.addEventListener('load', () => {
      this.equalizeHeights();
    });
  }

  init() {
    if (this.slider) return;

    const sliderEl = this.querySelector(".testimonial-swiper");
    const nextBtn = this.querySelector(".swiper-button-next");
    const prevBtn = this.querySelector(".swiper-button-prev");
    const paginationEl = this.querySelector(".swiper-pagination");
    const desktopSlides = Number(this.dataset.desktopSlides) || 3;
    const autoplayEnabled = this.dataset.autoplay === 'true';
    const loopEnabled = this.dataset.loop === 'true';
    const autoplaySpeed = Number(this.dataset.autoplaySpeed) || 3000;

    this.slider = new Swiper(sliderEl, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop:loopEnabled,
      autoplay: autoplayEnabled
  ? {
      delay: autoplaySpeed,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    }
  : false,
      breakpoints: {
        640: { slidesPerView: 2 },
        900: { slidesPerView: 3 },
        1400: { slidesPerView: desktopSlides }
      },

      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },

      pagination: {
        el: paginationEl,
        clickable: true,
      },

      observer: true,
      observeParents: true,

      on: {
        init: () => {
          this.equalizeHeights();
        },

        resize: () => {
          clearTimeout(this._resizeTimer);
          this._resizeTimer = setTimeout(() => {
            this.equalizeHeights();
          }, 150);
        },

        imagesReady: () => {
          this.equalizeHeights();
        }
      }
    });
  }

  equalizeHeights() {
    if (!this.slider) return;

    const slides = this.querySelectorAll('.swiper-slide');
    if (!slides.length) return;

    // Reset heights first
    slides.forEach(slide => {
      slide.style.height = 'auto';
    });

    let maxHeight = 0;

    slides.forEach(slide => {
      const height = slide.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    slides.forEach(slide => {
      slide.style.height = `${maxHeight}px`;
    });
  }

  disconnectedCallback() {
    if (this.slider) {
      this.slider.destroy(true, true);
      this.slider = null;
    }

    this._initialized = false;
    clearTimeout(this._resizeTimer);
  }
}

customElements.define('testimonial-slider', TestimonialSlider);



class MobileMenuDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addAccordionListeners();
  }

  addAccordionListeners() {
    const toggles = this.querySelectorAll(".accordion-toggle button");
    toggles.forEach((button) => {
      button.addEventListener("click", () => {
        const toggle = button.closest(".accordion-toggle");
        const content = toggle?.nextElementSibling;
        const isOpen = toggle.classList.contains("active");
        const plus = toggle.querySelector?.(".plus_vertical");

        this.closeSiblings(toggle);

        if (content?.classList.contains("accordion-content")) {
          toggle.classList.toggle("active", !isOpen);
          content.classList.toggle("active", !isOpen);
          plus?.classList.toggle("rot", !isOpen);

          if (isOpen) {
            this.slideUp(content);
          } else {
            this.slideDown(content);
          }
        }
      });
    });
  }

  slideDown(el) {
    el.style.maxHeight = el.scrollHeight + "px";

    requestAnimationFrame(() => {
      const parentAccordion = el.closest(".main-accordion-content");
      if (parentAccordion) {
        parentAccordion.style.maxHeight =
          parentAccordion.scrollHeight + el.scrollHeight + "px";
      }
    });
  }

  slideUp(el) {
    el.style.maxHeight = "0";

    requestAnimationFrame(() => {
      const parentAccordion = el.closest(".accordion-content");
      if (parentAccordion && parentAccordion !== el) {
        parentAccordion.style.maxHeight = parentAccordion.scrollHeight + "px";
      }
    });
  }

  closeSiblings(currentToggle) {
    const parentWrapper =
      currentToggle.closest(".accordion-wrapper") ||
      currentToggle.parentElement.parentElement;

    const allToggles = parentWrapper.querySelectorAll(".accordion-toggle");

    allToggles.forEach((toggle) => {
      if (toggle === currentToggle) return;

      const content = toggle.nextElementSibling;

      if (content?.classList.contains("accordion-content")) {
        toggle.classList.remove("active");
        content.classList.remove("active");
        toggle.querySelector?.(".plus_vertical")?.classList.remove("rot");
        this.slideUp(content);
      }
    });
  }
}

customElements.define("menudrawer-mobile", MobileMenuDrawer);



const openBtns = document.querySelectorAll(".drawer_open_btn");
const closeBtns = document.querySelectorAll(".drawer_close_btn");
const drawers = document.querySelectorAll(".drawer-wrapper");

let lastFocusedButton = null;
const DRAWER_INPUT_MODALITY_KEY = "__nexusLastInputWasKeyboard";

if (typeof window[DRAWER_INPUT_MODALITY_KEY] === "undefined") {
  window[DRAWER_INPUT_MODALITY_KEY] = false;
}

function markKeyboardNavigation() {
  window[DRAWER_INPUT_MODALITY_KEY] = true;
}

function markPointerNavigation() {
  window[DRAWER_INPUT_MODALITY_KEY] = false;
}

document.addEventListener("keydown", (event) => {
  if (event.metaKey || event.altKey || event.ctrlKey) return;
  markKeyboardNavigation();
}, true);

document.addEventListener("pointerdown", markPointerNavigation, true);
document.addEventListener("mousedown", markPointerNavigation, true);
document.addEventListener("touchstart", markPointerNavigation, true);

drawers.forEach((drawer) => {
  const focusableElements = drawer.querySelectorAll("button, input:not([type='hidden']), a, select, textarea");
  focusableElements.forEach((el) => {
    el.setAttribute("tabindex", "-1");
  });
});

function closeAllDrawers() {
  drawers.forEach((drawer) => {
    if (drawer.__closingTimer) {
      clearTimeout(drawer.__closingTimer);
      drawer.__closingTimer = null;
    }
    drawer.classList.remove("closing");
    drawer.classList.remove("active");
    drawer.classList.remove("content_fetched"); 
    drawer.setAttribute("aria-hidden", "true");
  });
}


function trapFocus(event, drawer) {
  const focusableElements = drawer.querySelectorAll("button, input:not([type='hidden']), a, select, textarea");
  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];

  if (event.key === "Tab") {
    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  }
}

function openDrawer(drawer, button) {
  closeAllDrawers();
  if (drawer) {
    if (drawer.__closingTimer) {
      clearTimeout(drawer.__closingTimer);
      drawer.__closingTimer = null;
    }

    lastFocusedButton = button;

    drawer.classList.remove("closing");
    drawer.classList.add("active");
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("overflow-hidden");
    //  document.querySelector(".header_block").style.zIndex = "0";

     if (drawer.hasAttribute('inert')) {
      drawer.removeAttribute('inert');
    }

    const focusableElements = drawer.querySelectorAll("button, input:not([type='hidden']), a, select, textarea");
    focusableElements.forEach((el) => {
      el.setAttribute("tabindex", "0");
    }); 

    const autoFocusInput = drawer.querySelector('input[type="text"], input[type="search"]');
    if (autoFocusInput) {
      autoFocusInput.focus();
    } else if (focusableElements.length) {
      focusableElements[0].focus();
    }

    window.whenLenisReady(lenis => {
      lenis.stop();
    });


    drawer.addEventListener("keydown", (event) => trapFocus(event, drawer));
  }
}

function closeDrawer(drawer, options = {}) {
  const shouldRestoreFocus =
    typeof options.restoreFocus === "boolean"
      ? options.restoreFocus
      : window[DRAWER_INPUT_MODALITY_KEY] === true;
  const shouldAnimateClose = options.animateClose === true;

  if (drawer) {
    if (drawer.__closingTimer) {
      clearTimeout(drawer.__closingTimer);
      drawer.__closingTimer = null;
    }

    if (shouldAnimateClose) {
      drawer.classList.add("closing");
      drawer.__closingTimer = setTimeout(() => {
        drawer.classList.remove("closing");
        drawer.__closingTimer = null;
      }, 600);
    } else {
      drawer.classList.remove("closing");
    }

    drawer.classList.remove("active");
    drawer.setAttribute("aria-hidden", "true");
    drawer.setAttribute('inert', '');
    document.body.classList.remove("overflow-hidden");
    if (drawer.classList.contains("mobile_filter_drawer_wrapper")) {
      setTimeout(() => {
        document.querySelector(".header_block").style.zIndex = "4";
      }, 200);
    } else if(drawer.classList.contains('quick-view-wrapper')) {
     const placeholderTemplate = document.getElementById('quick-view-drawer_placeholder_template');
     const contentWrapper = drawer.querySelector('.quick-view-main-inner');

      if (placeholderTemplate && contentWrapper) {
        contentWrapper.innerHTML = placeholderTemplate.innerHTML;
      }
    }

    const focusableElements = drawer.querySelectorAll("input, button, a");
    focusableElements.forEach((el) => {
      el.setAttribute("tabindex", "-1");
    });

    if (shouldRestoreFocus && lastFocusedButton) {
      lastFocusedButton.focus();
      lastFocusedButton = null;
    } else if (!shouldRestoreFocus) {
      lastFocusedButton = null;
    }

   window.whenLenisReady(lenis => {
    lenis.start();
  });

  }
}

function initDrawerOpenButtons() {
  const openBtns = document.querySelectorAll('[data-drawer]');

  openBtns.forEach((button) => {
    if (!button.hasAttribute('data-drawer-initialized')) {
      button.setAttribute('data-drawer-initialized', 'true'); 

      button.addEventListener("click", async (event) => {
        event.preventDefault();
        const drawerId = button.getAttribute("data-drawer");
        const drawer = document.getElementById(drawerId);
        if (drawer) {
          openDrawer(drawer, button);
        }
      });
    }
  });
}

document.addEventListener("DOMContentLoaded", initDrawerOpenButtons);
document.addEventListener("shopify:section:load", initDrawerOpenButtons);
document.addEventListener("shopify:section:unload", initDrawerOpenButtons);


function bindDrawerCloseButtons() {
  document.querySelectorAll('.drawer_close_btn').forEach((button) => {
    if (button.dataset.closeInitialized) return; // avoid rebinding
    button.dataset.closeInitialized = "true";

    button.addEventListener("click", () => {
      const drawer = button.closest(".drawer-wrapper");
      closeDrawer(drawer, {
        restoreFocus: window[DRAWER_INPUT_MODALITY_KEY] === true,
        animateClose: true,
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", bindDrawerCloseButtons);
document.addEventListener("shopify:section:load", bindDrawerCloseButtons);


drawers.forEach((drawer) => {
  drawer.addEventListener("click", (event) => {
    if (event.target === drawer) {
      closeDrawer(drawer, {
        restoreFocus: false,
        animateClose: true,
      });
    }
  });

  drawer.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeDrawer(drawer, {
        restoreFocus: true,
        animateClose: true,
      });
    }
  });

  const Inner = drawer.querySelector(".drawer-wrapper_inner");

});


class CartDrawerClose extends HTMLElement {
  constructor() {
    super();
    this.closeBtn = this.querySelector('.drawer_close_btn');
    this.drawer = this.closest('.cart_drawer_wrapper');
  }
 
  connectedCallback() {
    this.closeBtn.addEventListener('click', this.handleClose.bind(this));
  }

  handleClose() {
    closeDrawer(this.drawer, {
      animateClose: true,
    });
  }
}

customElements.define('cart-drawer-close', CartDrawerClose);

class FilterDrawerClose extends HTMLElement {
  connectedCallback() {
    if (typeof bindDrawerCloseButtons === 'function') {
      bindDrawerCloseButtons();
    }
  }
}

if (!customElements.get('filter-drawer-close')) {
  customElements.define('filter-drawer-close', FilterDrawerClose);
}



document.addEventListener("DOMContentLoaded", () => {
  const enrichImageAltText = () => {
    const imgs = document.querySelectorAll("img:not([alt]), img[alt='']");
    imgs.forEach(img => {
    if (!img.hasAttribute("alt") || img.alt.trim() === "") {
      
      let altText = "";

      const src = img.getAttribute("src") || "";
      const fileName = src.split("/").pop().split("?")[0].split(".")[0];

      if (fileName) {
        altText = fileName
          .replace(/[-_]/g, " ")
          .replace(/\d+/g, "")             
          .trim();
      }

      if (!altText && img.closest("[aria-label]")) {
        altText = img.closest("[aria-label]").getAttribute("aria-label");
      }

      if (!altText) {
        altText = "Image";
      }

      img.setAttribute("alt", altText);
    }
    });
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(enrichImageAltText, { timeout: 1200 });
  } else {
    setTimeout(enrichImageAltText, 250);
  }
});

 
// BUTTON HOVER EFFECT (only for pointer/hover devices)
if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
  const setButtonRipplePosition = (e) => {
    if (!(e.target instanceof Element)) return;

    const btn = e.target.closest('.btn');
    if (!btn) return;

    const related = e.relatedTarget;
    if (related instanceof Element && btn.contains(related)) return;

    const parentOffset = btn.getBoundingClientRect();
    const relX = e.clientX - parentOffset.left;
    const relY = e.clientY - parentOffset.top;

    const span = btn.querySelector('span.animate');
    if (span) {
      span.style.top = `${relY}px`;
      span.style.left = `${relX}px`;
    }
  };

  document.addEventListener('mouseover', setButtonRipplePosition);
  document.addEventListener('mouseout', setButtonRipplePosition);
}


class CategoryTabs extends HTMLElement {
  connectedCallback() {
    this.tabButtons = [...this.querySelectorAll('.cat-tab-btn')];
    this.tabPanels  = [...this.querySelectorAll("[slot='panels'] .cat-tab-panel")];

    this.activate(0);

    this.tabButtons.forEach((btn, i) => {
      btn.addEventListener("click", () => this.activate(i));
    });
  }

  activate(index) {

    this.tabButtons.forEach((btn, i) => {
      const active = i === index;
      btn.classList.toggle("active", active);
    });

    this.tabPanels.forEach((panel, i) => {
      const active = i === index;

      if (active) {
        panel.hidden = false;
        panel.offsetHeight;
        panel.classList.add("active");
      } else {
        panel.classList.remove("active");

        panel.addEventListener(
          "transitionend",
          () => {
            if (!panel.classList.contains("active")) {
              panel.hidden = true;
            }
          },
          { once: true }
        );
      }

      const focusable = panel.querySelectorAll("a, button, input, [tabindex]");

      focusable.forEach(el => {
        if (!active) {
          el.tabIndex = -1;
          return;
        }

        if (el.closest(".product_title_p")) {
          el.tabIndex = -1;
          return;
        }

        const imageWrap = el.closest(".product_block_img_info");
        if (imageWrap) {
          const firstLink = imageWrap.querySelector("a");
          el.tabIndex = el === firstLink ? 0 : -1;
          return;
        }

        el.tabIndex = 0;
      });
    });

    setTimeout(() => {
      const activePanel = this.tabPanels[index];
      if (!activePanel) return;

      activePanel.querySelectorAll('collection-product-variant').forEach(el => {
        el.mainSwiper?.update();
        el.thumbSwiper?.update();
      });

      window.whenSwiperReady(() => {
        activePanel.querySelectorAll('.swiper').forEach(slider => {
          if (slider.swiper) {
            slider.swiper.update();
            return;
          }

          new Swiper(slider, {
            slidesPerView: 4,
            spaceBetween: 16,
            navigation: {
              nextEl: slider.querySelector('.swiper-main-button-next'),
              prevEl: slider.querySelector('.swiper-main-button-prev'),
            },
              scrollbar: {
              el: slider.querySelector('.swiper-scrollbar'),
              draggable: true,
              snapOnRelease: true,
            },

            observer: true,
            observeParents: true,
            breakpoints: {
              0: { slidesPerView: 1.2 },
              640: { slidesPerView: 3 },
              900: { slidesPerView: 3 },
              1300: { slidesPerView: 4 }
            }
          });
        });
      });

      requestAnimationFrame(() => {
        window.dispatchEvent(new Event('resize'));
      });

    }, 100);
  }
}

customElements.define("category-tabs", CategoryTabs);

class MediaGallery extends HTMLElement {
  constructor() {
    super();
    this.videos = [];
    this.iframes = [];
    this.cleanupResize = null;
    this._initialized = false;
    this.scrollContainer = null;
    this.scrollRaf = null;
    this.scrollHandler = null;
    this.currentThumbProgress = 0;
    this.targetThumbProgress = 0;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.mainSlider = this.querySelector(".main_media_slider_wrapper");
    this.thumbSlider = this.querySelector(".thumbnail_media_slider_wrapper");
    this.galleryWrapper = this.closest(".product_media_gallery");
    this.scrollContainer = this.closest(".product-main-outer");
    if (!this.mainSlider || !this.thumbSlider) return;

    lazyInit(this, () => {
    window.whenSwiperReady(() => this.init());
  });
  }

  init() {
    if (this.swiper || this.thumbsSwiper) return;

    this.isVertical = this.getAttribute("vertical") === "true";

    this.thumbsSwiper = new Swiper(this.thumbSlider, {
      direction: this.isVertical ? "vertical" : "horizontal",
      slidesPerView: this.isVertical ? 3 : 5,
      spaceBetween: 10,
      speed: 1000, 
      watchSlidesProgress: true,
      freeMode: true,
      freeModeMomentum: true, 
      allowTouchMove: true, 
      navigation: {
        nextEl: this.thumbSlider.querySelector(".swiper-button-next"),
        prevEl: this.thumbSlider.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        0: {
          slidesPerView: 4, 
          direction: "horizontal",
          allowTouchMove: true,
        },
        900: {
          slidesPerView: this.isVertical ? 3 : 5,
          direction: this.isVertical ? "vertical" : "horizontal",
        },
      },
    });

    this.swiper = new Swiper(this.mainSlider, {
      slidesPerView: 1,
      spaceBetween: 16,
      speed: 1000,
      autoHeight: true,
      allowTouchMove: false,
      simulateTouch: false,
      navigation: {
        nextEl: this.mainSlider.querySelector(".swiper-button-next"),
        prevEl: this.mainSlider.querySelector(".swiper-button-prev"),
      },
      thumbs: { swiper: this.thumbsSwiper },
      on: {
        slideChange: () => this.pauseAllMedia(),
      },
    });

    this.collectMedia();
    this.bindMediaHandlers();
    this.setupThumbnailClick();
    this.observeHeight();
    this.dispatchEvent(
      new CustomEvent("media-slider-ready", { detail: this.swiper })
    );
  }

  collectMedia() {
    this.videos = [...this.querySelectorAll("video")];
    this.iframes = [
      ...this.querySelectorAll(
        "iframe[src*='youtube'], iframe[src*='vimeo']"
      ),
    ];
  }
  pauseAllMedia(except = null) {
    this.videos.forEach(v => v !== except && v.pause());

    this.iframes.forEach(iframe => {
      if (iframe === except) return;
      iframe.contentWindow?.postMessage(
        iframe.src.includes("youtube")
          ? JSON.stringify({ event: "command", func: "pauseVideo", args: [] })
          : JSON.stringify({ method: "pause" }),
        "*"
      );
    });

    this.querySelectorAll("product-model").forEach(model => {
      if (model !== except && model.modelViewerUI) {
        model.modelViewerUI.pause();
      }
    });
  }

  bindMediaHandlers() {
    this.videos.forEach(video => {
      const wrapper = video.closest(".media_video_wrapper");
      const overlay = wrapper?.querySelector(".video_overlay");
      const btn = wrapper?.querySelector(".icon_wrapper");

      const play = e => {
        e.preventDefault();
        e.stopPropagation();
        this.pauseAllMedia(video);
        video.play();
      };

      overlay?.addEventListener("click", play);
      btn?.addEventListener("click", play);

      // e.preventDefault() suppresses the browser's built-in click-to-toggle
      // behaviour on <video controls>, which would otherwise re-play the video
      // immediately after our pause() call.
      video.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (video.paused) {
          this.pauseAllMedia(video);
          video.play();
        } else {
          video.pause();
        }
      });

      // Keep overlay / button in sync with the actual video play state,
      // regardless of what triggered the change (click, slideChange, etc.).
      video.addEventListener("play", () => {
        if (btn) btn.style.display = "none";
        if (overlay) overlay.style.display = "none";
      });

      video.addEventListener("pause", () => {
        if (btn) btn.style.display = "flex";
        if (overlay) overlay.style.display = "block";
      });
    });
  }

  setupThumbnailClick() {
    this.querySelectorAll(
      ".thumbnail_media_slider_wrapper .swiper-slide"
    ).forEach(slide => {
      slide.addEventListener("click", () => {
        const pos =
          slide.querySelector(".product_media_wrapper")?.dataset.position;
        if (!pos) return;

        const slides = [
          ...this.querySelectorAll(
            ".main_media_slider_wrapper .product_media_wrapper"
          ),
        ];

        const index = slides.findIndex(
          s => s.dataset.position === pos
        );

        if (index !== -1) {
          this.pauseAllMedia();
          this.swiper.slideTo(index);
        }
      });
    });
  }

  observeHeight() {
    if (!this.isVertical || !this.galleryWrapper) return;

    this.cleanupResize = rafResizeObserver(
      this.mainSlider,
      height => {
        this.galleryWrapper.style.setProperty(
          "--vertical-match",
          `${height}px`
        );
      }
    );
  }

  disconnectedCallback() {
    if (this.scrollHandler) {
  window.removeEventListener("scroll", this.scrollHandler);
  window.removeEventListener("resize", this.scrollHandler);
}

if (this.scrollRaf) {
  cancelAnimationFrame(this.scrollRaf);
}
    this.cleanupResize?.();
    this.swiper?.destroy(true, true);
    this.thumbsSwiper?.destroy(true, true);
    this.swiper = null;
    this.thumbsSwiper = null;
    this._initialized = false;
  }
}

customElements.define("media-gallery", MediaGallery);


class VariantPicker extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("change", (e) => {
      const target = e.target.tagName === "SELECT"
        ? e.target.selectedOptions[0]
        : e.target;

      this.closest("product-info").dispatchEvent(
        new CustomEvent("variant-change", {
          detail: {
            target: target,
            selectedOptionValues: this.selectedOptionValues
          }
        })
      );
    });
  }

  get selectedOptionValues() {
    let selected = [];

    this.querySelectorAll("input:checked").forEach((el) => {
      if (el.dataset.valueId) selected.push(el.dataset.valueId);
    });

    this.querySelectorAll("select").forEach((select) => {
      const opt = select.selectedOptions[0];
      if (opt?.dataset.valueId) {
        selected.push(opt.dataset.valueId);
      }
    });

    return selected;
  }
}

customElements.define("variant-picker", VariantPicker);


class ProductInfo extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;     
    this.originalSectionId = this.dataset.originalSectionId;
    this.productUrl = this.dataset.productUrl;  
    this.updateUrl = this.dataset.updateUrl;
    this.isMainProduct = this.dataset.mainProduct;
    this._onVariantChange = this._onVariantChange.bind(this);
    this.variantUpdateController = null;
  }

  connectedCallback() {
    this.addEventListener('variant-change', this._onVariantChange);
  }

  disconnectedCallback() {
    this.removeEventListener('variant-change', this._onVariantChange);
    this.variantUpdateController?.abort();
  }

  _onVariantChange(e) {
    const optionValues = e?.detail?.selectedOptionValues || [];

    const url = this.buildUrl(this.sectionId, this.productUrl, optionValues);
    this.handleUpdate(url);  
    document.dispatchEvent(
      new CustomEvent('pickup:check', {
        bubbles: true
      })
    ) 
  }

  buildUrl(sectionId, productUrl, values) {
    const url = new URL(productUrl, window.location.origin);
    url.searchParams.set('option_values', values.join(','));

    if(this.isMainProduct != 'true') {
      const requestSectionId = this.originalSectionId || sectionId;
      url.searchParams.set('section_id', requestSectionId);  
    }
    
    return url.toString(); 
  }

  handleUpdate(url) {
    this.variantUpdateController?.abort();
    this.variantUpdateController = new AbortController();

    fetch(url, { signal: this.variantUpdateController.signal })
      .then((res) => res.text())
      .then((data) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = data;

        const fetchedProductInfo = tempDiv.querySelector('product-info');
        if (!fetchedProductInfo) return;

        if (this.sectionId && this.originalSectionId && this.sectionId !== this.originalSectionId) {
          tempDiv.innerHTML = tempDiv.innerHTML.replaceAll(this.originalSectionId, this.sectionId);
        }

        const remappedProductInfo = tempDiv.querySelector(`product-info[data-section-id="${this.sectionId}"]`) || fetchedProductInfo;
        remappedProductInfo.dataset.updateUrl = this.updateUrl;
        remappedProductInfo.dataset.sectionId = this.sectionId;

        const currentProductInfo = document.querySelector(`product-info[data-section-id="${this.sectionId}"]`);
        if (!currentProductInfo) return;

        const activeEl = document.activeElement;
        const focusedId = activeEl && currentProductInfo.contains(activeEl) ? activeEl.id : null;

        currentProductInfo.innerHTML = remappedProductInfo.innerHTML;

        if (focusedId) {
          const elToFocus = currentProductInfo.querySelector(`#${CSS.escape(focusedId)}`);
          elToFocus?.focus({ preventScroll: true });
        }

        const variantJson = tempDiv.querySelector('script[data-selected-variant]');
        if (!variantJson) return;

        if(this.updateUrl == 'true') {
          this.handleUpdateUrl(variantJson);
        }

        const root =
          this.closest('.product-main-inner') ||
          this.closest('.featured_product_inner') ||
          this.closest('.quick-view-drawer_inner');

        if (!root) return;

        const slider = root.querySelector('media-gallery');
        if (!slider) return;

        const variant = JSON.parse(variantJson.textContent);
        const targetPos = variant?.featured_media?.position;
        if (!targetPos) return;

        const moveToVariantImage = () => {
          if (!slider.swiper) return;

          const slides = [...slider.querySelectorAll('.product_media_wrapper')];
          const targetIndex = slides.findIndex(
            slide => slide.dataset.position == targetPos 
          );

          if (targetIndex !== -1) {
            requestAnimationFrame(() => {
            slider.swiper.slideTo(targetIndex);
          });
          }
        };


        if (slider.swiper) {
          moveToVariantImage();           
        } else {
          slider.addEventListener(
            'media-slider-ready',
            moveToVariantImage,
            { once: true }                
          );
        }
        
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') {
          console.error('Variant update failed:', error);
        }
      })
      .finally(() => {
        this.variantUpdateController = null;
      });
  }
 
    handleUpdateUrl(variantScript) {
    const isQuickContext =
      this.sectionId?.includes('quick-view') ||
      this.sectionId?.includes('quick-add') ||
      Boolean(this.closest('.quick-view-drawer_inner'));

    if (isQuickContext) return;
    if (this.isMainProduct !== 'true') return;
    if (!variantScript?.textContent) return;

    const selectedVariant = JSON.parse(variantScript.textContent);
    if (!selectedVariant?.id) return;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', selectedVariant.id);

    // Replace instead of push (no history pollution)
    window.history.replaceState({}, '', url.toString());

    this.handlePickup(selectedVariant.id);
  }

  
  handlePickup(id) {
     let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith("/")) {
          rootUrl = rootUrl + "/";
        }

    fetch(`${rootUrl}variants/${id}/?section_id=pickup-availability-section`)
    .then((res) => res.text())
    .then((data) => {
      const container = document.querySelector('[data-store-availability-container]');
      const pickupHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('.pa_wrapper');

      if(container && pickupHTML) {
        container.innerHTML = pickupHTML.innerHTML;
        const drawer = container.querySelector('pickup-availability-drawer');
        const btn = container.querySelector('.pickup_availability_information_btn');
        const cursor = document.querySelector('.cursor_pointer');

        if(cursor && drawer) {
          drawer.addEventListener('mouseenter', () => {
            cursor.classList.add('close');
          })

          drawer.addEventListener('mouseleave', () => {
            cursor.classList.remove('close');
          })

          drawer.querySelector('.drawer-wrapper_inner').addEventListener('mouseenter', () => {
            cursor.classList.remove('close')
          })

          drawer.querySelector('.drawer-wrapper_inner').addEventListener('mouseleave', () => {
            cursor.classList.add('close')
          })
        }

        if(drawer && btn) {
          btn.addEventListener('click', () => {
            openDrawer(drawer, btn);
          })
        }

        if(drawer) {
          drawer.addEventListener('click', () => {
            closeDrawer(drawer)
          })
        }
      }     

      
    })
    .catch((e) => {
      console.error('Error: ', e)
    })  
  }
} 

customElements.define('product-info', ProductInfo); 

class ProductQuantityWrapper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.minus = this.querySelector('[data-minus]');
    this.plus = this.querySelector('[data-plus]');
    this.input = this.querySelector('input[name="product_quantity"]');
    this.value = this.input.value;

    this.plus.addEventListener('click', this.handleChange.bind(this));
    this.minus.addEventListener('click', this.handleChange.bind(this));
    const debouncedHandler = this._debounce((e) => this.handleInput(e), 1000);
    this.input.addEventListener('input', debouncedHandler);
  }

  handleChange(e) {
    let attr = e.currentTarget.dataset.action;
    if(attr == 'plus') {
      this.value = parseInt(this.value) + 1;      
    }  else {
      this.value = parseInt(this.value) - 1;
    }

    if(this.value > 1) {
      this.minus.removeAttribute('disabled');
    } else {
      this.minus.setAttribute('disabled', '');
    }

    this.input.value = this.value;
    this.closest('product-info').querySelector('input[name="quantity"]').value = this.value;
  }

  handleInput(e) {
    let value = e.target.value;
    value = parseInt(value)

    if(value == 0 || isNaN(value)) {
      value = 1;
    }
    this.value = value;

    if(this.value > 1) {
      this.minus.removeAttribute('disabled');
    } else {
      this.minus.setAttribute('disabled', '');
    }

    this.input.value = this.value;
    this.closest('product-info').querySelector('input[name="quantity"]').value = this.value;

  }

   _debounce(fn, wait = 1000) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('product-quantity-wrapper', ProductQuantityWrapper);
 

class ProductForm extends HTMLElement {
  constructor() {  
    super();
    this.form = this.querySelector('form.product_form');
    this.button = this.querySelector('.add_to_cart_button');
    this.icon = this.button.querySelector('.icon_wrapper') || this.button.querySelector('.atc_text');
    this.mainInput = this.querySelector('input[name="id"]');
    this.cart = document.querySelector('cart-drawer');
    this.loader = this.button.querySelector('.form_loader');
    this.info = this.closest('product-info');
    if(this.info) {
      this.giftWrap = this.info.querySelector('#product_gift_wrapp');
    }
  }

  connectedCallback() {
    this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
  }

  handleFormSubmit(e) {
    e.preventDefault();
    this.icon.classList.add('hidden');
    if(this.icon && this.loader) {
      this.icon.classList.add('hidden');
      this.loader.classList.remove('hidden');
    } 

    const formData = new FormData(this.form);
    const payload = {};
    for (const [key, value] of formData.entries()) {
    // Detect line item properties
    const propertyMatch = key.match(/^properties\[(.+)\]$/);
    if (propertyMatch) {
      if (!payload.properties) payload.properties = {};
      payload.properties[propertyMatch[1]] = value;
    } else {
      payload[key] = value;
    }
  }
   // const payload = Object.fromEntries(formData.entries());

   const items = [payload];
   
   if(this.giftWrap && this.giftWrap.checked) {
    const giftWrapId = this.giftWrap.value;
    items.push({
      id: giftWrapId,
      quantity: 1,
      parent_id: this.mainInput.value,
      properties: {
        for: `${this.mainInput.dataset.title} (${this.mainInput.dataset.variantTitle})`
      }
    })
   }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items })
    })
    .then(async (res) =>{
      const data = await res.json();
      if(!res.ok) {
        let message = '';

        if(data.errors) {         
          Object.entries(data.errors).forEach(([field, messages]) => {
          if(Object.keys(data.errors).length > 1) {
              message += `<div>${messages[0]}</div>`            
          } else {
            message = messages[0]
          }
        });          
        } else if(data.description) {
          message = data.description;
        } else if(data.message) {
          message = data.message;
        }

        const errorWrapper = this.querySelector('.product_card_cart_error');
        const error = this.closest('product-info');
        
        if(errorWrapper) {
          errorWrapper.innerHTML = message;
          errorWrapper.classList.add('show');

          setTimeout(() => {
            errorWrapper.classList.remove('show');
          }, 2000)
        }      
        
        if(error) {          
          error.querySelector('.product_quantity_error').innerHTML = message;
          error.querySelector('.product_quantity_error').classList.remove('hidden');
        }

        const rawCartData = await fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-count,cart-main').then((res) => res.json());        
      const cartData = {          
          'sections': rawCartData,
          'message': message,          
        }

      document.dispatchEvent(
        new CustomEvent('cart-update', {
          detail: cartData,
          bubbles: true
        })
      )

        throw new Error(data.description || 'Error add to cart');
      }
      return data;
    })
    .then(async (data) => {
      if(this.cart) {
        const rawCartData = await fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-count,cart-main').then((res) => res.json());        
        const cartData = {
            'sections': rawCartData,
            'button': this.button
          }

        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: cartData,
            bubbles: true
          })
        )
      } else {
        window.location.href = window.Shopify.routes.root + 'cart'
      }
    })
    .finally(() => {
      this.icon.classList.remove('hidden');
      this.loader.classList.add('hidden')
    })
  }
}

customElements.define('product-form', ProductForm);



class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.loader = this.querySelector('.loader_wrapper');
  }

  connectedCallback() {
    document.addEventListener('cart-update', this.cartUpdate.bind(this));
  }

  cartUpdate(e) {
    // CART DRAWER UPDATE
    let tempDiv = document.createElement('div');
    let newDrawer = e.detail.sections['cart-drawer'];
    let error = e.detail.message;
    let button = e.detail.button;
    
    if(newDrawer) {
      tempDiv.innerHTML = newDrawer;
    }
    let cartDrawer = document.querySelector('.cart_drawer_inner');
    if(cartDrawer) {
      cartDrawer.innerHTML = tempDiv.querySelector('.cart_drawer_inner').innerHTML;    
      if(error && e.detail.line) {
        const lineWrapper = cartDrawer.querySelector(`quantity-wrapper[data-line="${e.detail.line}"]`);
        if(lineWrapper) {
          lineWrapper.querySelector('.cart_quantity_error').textContent = error;
          lineWrapper.querySelector('.cart_quantity_error').classList.remove('hidden');
        }        
      }
    }

    // CART COUNT UPDATE
    let temp = document.createElement('div');
    let newCount = e.detail.sections['cart-count'];
    if(newCount) {
      temp.innerHTML = newCount;
    }

    document.querySelector('.cart-count-text').innerHTML = temp.querySelector('.cart-count-text').innerHTML;

    const drawer = document.querySelector('.cart_drawer_wrapper');    
    if(drawer && button) {    
      const productWrapper = document.querySelector('.shopify-section.main-product-section');
      if(productWrapper) {
        // productWrapper.style.zIndex = '0'
      }
      openDrawer(drawer,button)
    }       
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartRemove extends HTMLElement {
  constructor() {
    super();
    this.link = this.querySelector('a');
    this.line = this.dataset.line;
    this.wrapper = this.closest('cart-drawer') || this.closest('cart-main');
    this.loader = this.wrapper.querySelector?.('.loader_wrapper');
  }

  connectedCallback() {
    this.link.addEventListener('click', this.handleRemove.bind(this));
  }

  handleRemove(e) {
    e.preventDefault();
    if(this.loader) {
      this.loader.classList.add('active');
    }

    const formData = {
      'line': this.line,
      'quantity': e.currentTarget.dataset.quantity,
      'sections': 'cart-drawer,cart-count,cart-main'
    }

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((res) => res.json())
    .then((data) => {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart-update', {
          detail: data,
          bubbles: true
        })
      )
    })
  }
}

customElements.define('cart-remove', CartRemove);

class CartMain extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    document.addEventListener('cart-update', this.handleCartPageUpdate.bind(this));
  }

  handleCartPageUpdate(e) {

    const tempCart = document.createElement('div');
    const newCart = e.detail.sections['cart-main'];
    let error = e.detail.message;
   
    if(newCart) {
      tempCart.innerHTML = newCart;
    }


    const oldCart = document.querySelector('cart-main');
    if(oldCart) {
      oldCart.querySelector('.cart_main_inner').innerHTML = tempCart.querySelector('.cart_main_inner').innerHTML;
      if(error && e.detail.line) {
        const lineWrapper = oldCart.querySelector(`quantity-wrapper[data-line="${e.detail.line}"]`);
        if(lineWrapper) {
          lineWrapper.querySelector('.cart_quantity_error').textContent = error;
          lineWrapper.querySelector('.cart_quantity_error').classList.remove('hidden');
        }        
      }
    }

    // CART COUNT UPDATE
    let temp = document.createElement('div');
    let newCount = e.detail.sections['cart-count'];
    if(newCount) {
      temp.innerHTML = newCount;
    }

    document.querySelector('.cart-count-text').innerHTML = temp.querySelector('.cart-count-text').innerHTML;     
  }
}

customElements.define('cart-main', CartMain);

class QuantityWrapper extends HTMLElement {
  constructor() {
    super();
    this.minusBtn = this.querySelector('[data-minus]');
    this.plusBtn = this.querySelector('[data-plus]');
    this.input = this.querySelector('input');   
    this.line = this.dataset.line; 
    this.wrapper = this.closest('cart-drawer') || this.closest('cart-main');
    this.loader = this.wrapper.querySelector('.loader_wrapper');
  }

  connectedCallback() {
    this.plusBtn.addEventListener('click', this.handleChange.bind(this));
    this.minusBtn.addEventListener('click', this.handleChange.bind(this));
    const debouncedHandler = this._debounce((e) => this.handleInput(e), 1000)
    this.input.addEventListener('input', debouncedHandler);
  }

  getValue(e) {
    if(e.currentTarget.hasAttribute('data-plus')) {
      let value = parseInt(this.input.value);
      value = value + 1;
      if(value == 1) {
        this.minusBtn.setAttribute('disabled', '');
      } else {
        this.minusBtn.removeAttribute('disabled');
      }

      this.input.value = value;
      return value;
    } else {
      let value = parseInt(this.input.value);
      value = value - 1;
      if(value == 1) {
        this.minusBtn.setAttribute('disabled', '');
      } else {
        this.minusBtn.removeAttribute('disabled');
      }

      this.input.value = value;
      return value;
    }
  }

  handleChange(e) {
    e.preventDefault();
    let value = this.getValue(e);
    
    if(this.loader) {
      this.loader.classList.add('active');
    }

    const formData = {
      'line': this.line,
      'quantity': value,
      'sections': 'cart-drawer,cart-count,cart-main'
    }

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(async (res) => {
      const data = await res.json();

      if(!res.ok) {        
        const rawCartData = await fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-count,cart-main').then((res) => res.json());        
        const cartData = {
          'line': this.line,
          'message': data.message || data.description,
          'sections': rawCartData,          
        }

        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: cartData,
            bubbles: true
          })
        )
        throw new Error(data.description || data.message || 'Request failed');        
      }

      return data;
    })
    .then((cartData) => {          
      document.documentElement.dispatchEvent(
        new CustomEvent('cart-update', {
          detail: cartData,          
          bubbles: true
        })
      )
    })
  }

  handleInput(e) {
    e.preventDefault();

    if(this.loader) {
      this.loader.classList.add('active');
    }

    const formData = {
      'line': this.line,
      'quantity': e.target.value,
      'sections': 'cart-drawer,cart-count,cart-main'
    }

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(async (res) => {
      const data = await res.json();

      if(!res.ok) {        
        const rawCartData = await fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-count,cart-main').then((res) => res.json());        
        const cartData = {
          'line': this.line,
          'message': data.message || data.description,
          'sections': rawCartData
        }

        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: cartData,
            bubbles: true
          })
        )
        throw new Error(data.description || data.message || 'Request failed');        
      }

      return data;
    })
    .then((cartData) => {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart-update', {
          detail: cartData,
          bubbles: true
        })
      ) 
    })
  }

  _debounce(fn, wait = 1000) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('quantity-wrapper', QuantityWrapper);
 

class CartDiscount extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
        this.input = this.querySelector('input[name="discount"]');
        this.inputValue = this.input.value;
        this.remove = this.querySelector('[data-discount-remove]');
        this.error = this.querySelector('.cart_discount_error');
        this.wrapper = this.closest('cart-drawer') || this.closest('cart-main');
        this.loader = this.wrapper.querySelector('.loader_wrapper');
  }

  connectedCallback() {
        this.input.addEventListener('input', this.handleInput.bind(this));
        this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
        if(this.remove) {
            this.remove.addEventListener('click', this.handleRemove.bind(this));
        }
    }

    handleInput(e) {
        e.preventDefault();
        this.inputValue = this.input.value;
    }

    handleFormSubmit(e) {
      e.preventDefault();

      if(this.loader) {
        this.loader.classList.add('active');
      }

      const formData = {
        discount: this.inputValue,
        sections: 'cart-drawer,cart-count,cart-main'
      }

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': "application/json"
        },
        body: JSON.stringify(formData)
      })
      .then((res) => res.json())
      .then((cartData) => {
        if(cartData.discount_codes[0].applicable == false) {
          if(this.error) {
            this.error.classList.remove('hidden');
            this.input.value = "";
          } 

          if(this.loader) {
           this.loader.classList.remove('active');
          }
        } else {
          document.documentElement.dispatchEvent(
            new CustomEvent('cart-update', {
              detail: cartData,
              bubbles: true
            })
          )
        }
      })
    }

    handleRemove(e) {
      e.preventDefault();

      if(this.loader) {
        this.loader.classList.add('active');      
      }  

      const formData = {
        discount: "",
        sections: "cart-drawer,cart-count,cart-main"
      }

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': "application/json",
        },
        body: JSON.stringify(formData)
      })
      .then((res) => res.json())
      .then((cartData) => {
        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: cartData,
            bubbles: true
          })
        )
      })
    }
}

customElements.define('discount-field', CartDiscount);

if (!customElements.get("cart-note")) {
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.textarea = this.querySelector("textarea[name='note']");
      this.debounceTimer = null;
      this.debounceDelay = 500;
    }

    connectedCallback() {
      if (!this.textarea) return;

      this.textarea.addEventListener("input", this.handleInput.bind(this));
    }

    disconnectedCallback() {
      if (!this.textarea) return;
      this.textarea.removeEventListener("input", this.handleInput);
    }

    handleInput(e) {
      const value = e.target.value;

      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.updateCartNote(value, e);
      }, this.debounceDelay);
    }

    updateCartNote(note, event) {
      fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ note }),
      }).then(() => {
        if (window.CartPerformance?.measureFromEvent) {
          CartPerformance.measureFromEvent(
            "note-update:user-action",
            event
          );
        }
      });
    }
  }

  customElements.define("cart-note", CartNote);
}


Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
 

class CollectionProductVariant extends HTMLElement {
  constructor() {
    super();

    this.card = this.querySelector('.collection-product-card');

    this.mainSwiperEl = this.querySelector('.product-media.swiper');

    this.resizeCleanup = null;
    this._initialized = false;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    lazyInit(this, () => {
      window.whenSwiperReady(() => this.init());
    });
  }

  init() {
    this.initSwiper();
    this.bindHoverSlide();
    this.bindFocusCleanup();
    this.bindHoverActive();
  }

  /* ================= MAIN SWIPER ================= */

  initSwiper() {
    if (!this.mainSwiperEl) return;

    this.mainSwiper = new Swiper(this.mainSwiperEl, {
      slidesPerView: 1,
      speed: 1000,
      allowTouchMove: false,
      effect: 'fade',
      fadeEffect: { crossFade: true },

      navigation: {
        nextEl: this.mainSwiperEl.querySelector('.swiper-button-next'),
        prevEl: this.mainSwiperEl.querySelector('.swiper-button-prev')
      },

      pagination: {
        el: this.mainSwiperEl.querySelector('.swiper-pagination'),
        clickable: true
      }
    });
  }

  /* ================= HOVER SLIDE ================= */

  bindHoverSlide() {
    if (this.getAttribute('secondary_hover') !== 'true') return;
    if (!this.mainSwiper || !this.mainSwiperEl) return;

    let hoverTimer;
    let didHoverChangeSlide = false;

    const hasSecondSlide = this.mainSwiper.slides.length > 1;
    if (!hasSecondSlide) return;

    this.mainSwiperEl.addEventListener('mouseenter', () => {
      const isFirstSlide =
        this.mainSwiper.realIndex === 0 || this.mainSwiper.activeIndex === 0;

      if (!isFirstSlide) {
        didHoverChangeSlide = false;
        return;
      }

      hoverTimer = setTimeout(() => {
        didHoverChangeSlide = true;

        this.mainSwiper.slideToLoop
          ? this.mainSwiper.slideToLoop(1)
          : this.mainSwiper.slideTo(1);
      }, 150);
    });

    this.mainSwiperEl.addEventListener('mouseleave', () => {
      clearTimeout(hoverTimer);

      if (!didHoverChangeSlide) return;

      this.mainSwiper.slideToLoop
        ? this.mainSwiper.slideToLoop(0)
        : this.mainSwiper.slideTo(0);

      didHoverChangeSlide = false;
    });
  }

  /* ================= UI BEHAVIOR ================= */

  bindFocusCleanup() {
    if (!this.card) return;

    this.card.addEventListener('mouseleave', () => {
      if (this.card.contains(document.activeElement)) {
        document.activeElement.blur();
      }
    });
  }

  bindHoverActive() {
    if (!this.card) return;

    const slider = this.card.closest('.product_block_slider');
    if (!slider) return;

    let timer = null;

    this.card.addEventListener('mouseenter', () => {
      clearTimeout(timer);
      slider.classList.add('active');
    });

    this.card.addEventListener('mouseleave', () => {
      timer = setTimeout(() => slider.classList.remove('active'), 300);
    });
  }

  /* ================= CLEANUP ================= */

  disconnectedCallback() {
    this.resizeCleanup?.();
    this.mainSwiper?.destroy(true, true);
    this._initialized = false;
  }
}

customElements.define('collection-product-variant', CollectionProductVariant);


class PageTransition extends HTMLElement {

  constructor() {
    super();

    window.addEventListener("beforeunload", () => {
      document.body.classList.add("page-loading");

      document.dispatchEvent(new CustomEvent("pageTransitionStart", {
        bubbles: true,
        detail: {
          direction: "out",
          timestamp: Date.now()
        }
      }));
    });

    const initOnLoad = () => {
      document.dispatchEvent(new CustomEvent("pageLoaded", {
        bubbles: true,
        detail: { timestamp: Date.now() }
      }));

      this.hide();
    };

    if (document.readyState === "loading") {
      window.addEventListener("DOMContentLoaded", initOnLoad, { once: true });
    } else {
      initOnLoad();
    }

    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
        document.body.classList.remove("page-loading");
      }
    });
  }

  hide() {
    this.style.transition = "opacity 1s";
    this.style.opacity = 0;

    setTimeout(() => {
      this.hidden = true;

      document.dispatchEvent(new CustomEvent("pageTransitionEnd", {
        bubbles: true,
        detail: { timestamp: Date.now() }
      }));

    }, 1200);
  }
}

customElements.define("page-load", PageTransition);

class CollectionShowcaseSlider extends HTMLElement {
  connectedCallback() {
    window.whenSwiperReady(() => {
      this.init();
    });
  }

  init() {
    if (this.initialized) return;

    this.textEl = this.querySelector('.collection-text-slider');
    this.imageEl = this.querySelector('.collection-image-slider');
    this.textSlidesPerView = Number(this.dataset.textSlidesPerView) || 3;
    this.textSlidesPerView = Math.max(1, Math.min(3, this.textSlidesPerView));

    if (!this.textEl || !this.imageEl) return;

    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.textSwiper = new Swiper(this.textEl, {
      slidesPerView: this.textSlidesPerView,
      centeredSlides: true, 
      spaceBetween: 20,
      loop: true,
      speed: 1200,
        watchSlidesProgress: true,
        autoplay: this.prefersReducedMotion ? false : {
          delay: 1500,
          disableOnInteraction: false,
          pauseOnMouseEnter: false
        },
        breakpoints: {
          0: { slidesPerView: 1 },
          350: { slidesPerView: 1 },
          640: { slidesPerView: Math.min(this.textSlidesPerView, 2) },
          1200: { slidesPerView: this.textSlidesPerView },
        }
    });

    this.imageSwiper = new Swiper(this.imageEl, {
      slidesPerView: 1,
      loop: true,
      speed: 1200,
      allowTouchMove: false,
      // effect: 'fade',
      // cubeEffect: {
      //   shadow: true,
      //   slideShadows: false
      // },
      watchSlidesProgress: true
    });

      this.textSwiper.on('slideChange', () => {
        const index = this.textSwiper.realIndex;

        if (this.imageSwiper.realIndex !== index) { 
          this.imageSwiper.slideToLoop(index);
        }
      });

      this.imageSwiper.on('slideChange', () => {
        const index = this.imageSwiper.realIndex;

        if (this.textSwiper.realIndex !== index) {
          this.textSwiper.slideToLoop(index);
        }
      });
 
    this.bindFocusSync();
    this.bindAutoplayControl(); 
    setTimeout(() => {
      const index = this.textSwiper.realIndex || 0;

      this.textSwiper.slideToLoop(index, 0);
      this.imageSwiper.slideToLoop(index, 0);

      this.textSwiper.update();
      this.imageSwiper.update();
       }, 0);
        this.initialized = true;
      }

      bindFocusSync() {
        this.isKeyboardUser = false;

        document.addEventListener('keydown', () => {
          this.isKeyboardUser = true;
        });

        document.addEventListener('mousedown', () => {
          this.isKeyboardUser = false;
        }); 
      }

      bindAutoplayControl() {
        if (!this.textSwiper?.autoplay) return;

        // Pause autoplay when image gets focus
        this.imageEl.addEventListener('focusin', () => {
          this.textSwiper.autoplay.stop();
        });

        this.imageEl.addEventListener('focusout', () => {
          this.textSwiper.autoplay.start();
        });
      }
}

customElements.define('collection-showcase-slider', CollectionShowcaseSlider);

class DualLayerSlider extends HTMLElement {
  connectedCallback() {
    lazyInit(this, () => {
    window.whenSwiperReady(() => this.init());
  });
  }

  init() {
    if (this.initialized) return;

    // Elements
    this.leftBgEl = this.querySelector('.left-bg');
    this.rightBgEl = this.querySelector('.right-bg');
    this.leftSmallEl = this.querySelector('.left-small');
    this.rightSmallEl = this.querySelector('.right-small');

    this.leftTextEl = this.querySelectorAll('.dual_inner')[0]?.querySelector('.vertical_scroll');
    this.rightTextEl = this.querySelectorAll('.dual_inner')[1]?.querySelector('.vertical_scroll');

    this.prevBtn = this.querySelector('.swiper-button-prev');
    this.nextBtn = this.querySelector('.swiper-button-next');

    // MASTER
    this.master = new Swiper(this.leftBgEl, {
      slidesPerView: 1,
      loop: true,
      speed: 1500,
      allowTouchMove: false,
      autoplay: {
        delay: 2500, 
        disableOnInteraction: true, 
        pauseOnMouseEnter: false 
      }
    });

    // IMAGE SLIDERS
    this.rightBg = new Swiper(this.rightBgEl, {
      slidesPerView: 1,
      loop: true,
      speed: 1500,
      allowTouchMove: false
    });

    this.leftSmall = new Swiper(this.leftSmallEl, {
      slidesPerView: 1,
      loop: true,
      speed: 1500,
      allowTouchMove: false
    });

    this.rightSmall = new Swiper(this.rightSmallEl, {
      slidesPerView: 1,
      loop: true,
      speed: 1500,
      allowTouchMove: false
    });

    // TEXT SLIDERS
    this.leftText = new Swiper(this.leftTextEl, {
      direction: 'vertical',
      slidesPerView: 1,
      loop: true,
      speed: 1500,
      allowTouchMove: false
    });

    this.rightText = new Swiper(this.rightTextEl, {
      direction: 'vertical',
      slidesPerView: 1,
      loop: true,
      speed: 1500,
      allowTouchMove: false
    });

    //  SYNC MASTER → ALL
    this.master.on('slideChangeTransitionStart', () => {
      const index = this.master.realIndex;

      this.rightBg.slideToLoop(index);
      this.leftSmall.slideToLoop(index);
      this.rightSmall.slideToLoop(index);

      this.leftText.slideToLoop(index);
      this.rightText.slideToLoop(index);
    });

    //  NAVIGATION
    this.nextBtn?.addEventListener('click', () => {
      this.master.slideNext();
    });

    this.prevBtn?.addEventListener('click', () => {
      this.master.slidePrev();
    });

    this.bindFocusSync();

    this.bindKeyboardNav();

    //  INITIAL SYNC FIX
    setTimeout(() => {
      const index = this.master.realIndex || 0;

      this.master.slideToLoop(index, 0);
      this.rightBg.slideToLoop(index, 0);
      this.leftSmall.slideToLoop(index, 0);
      this.rightSmall.slideToLoop(index, 0);

      this.leftText.slideToLoop(index, 0);
      this.rightText.slideToLoop(index, 0);
    }, 0);

    this.initialized = true;

    // setTimeout(() => {
    //   this.bindScroll();
    // }, 100);
  }
  bindScroll() {
  this.sectionTop = 0;
  this.sectionHeight = 0;

  this.updateScrollValues();

  this._boundOnScroll = this._boundOnScroll || this.onScroll.bind(this);
  this._boundUpdateScrollValues = this._boundUpdateScrollValues || this.updateScrollValues.bind(this);
  window.addEventListener('scroll', this._boundOnScroll, { passive: true });
  window.addEventListener('resize', this._boundUpdateScrollValues, { passive: true });
}

updateScrollValues() {
  const rect = this.getBoundingClientRect();
  this.sectionTop = rect.top + window.scrollY;
  this.sectionHeight = this.offsetHeight;
}

  onScroll() {
  if (!this.master) return;

  const scrollY = window.scrollY;

  const start = this.sectionTop;
  const end = this.sectionTop + this.sectionHeight - window.innerHeight;

  let progress = (scrollY - start) / (end - start);

  progress = Math.max(0, Math.min(1, progress));

  const totalSlides = this.master.slides.length;

  let index = Math.round(progress * (totalSlides - 1));

  // FORCE SLIDE CHANGE
  this.master.slideToLoop(index);
}

  bindFocusSync() {
    const links = this.querySelectorAll('.overlay_slider a');

    links.forEach(link => {
      link.addEventListener('focus', () => {
        const slide = link.closest('.swiper-slide');
        if (!slide) return;

        const index = Number(slide.getAttribute('data-swiper-slide-index'));
        if (isNaN(index)) return;

        this.master.slideToLoop(index);
      });
    });
  }

  //  Keyboard arrow support
  bindKeyboardNav() {
    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') {
        this.master.slideNext();
      }

      if (e.key === 'ArrowLeft') {
        this.master.slidePrev();
      }
    });
  }
}

customElements.define('dual-layer-slider', DualLayerSlider);

class VideoBackground extends HTMLElement {
  constructor() {
    super();

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
  }

  connectedCallback() {
    this.wrapper = this.querySelector('.animate-content-inner');
    this.content = this.querySelector('.header-block');

    if (!this.wrapper || !this.content) return;

    this.enabled = this.dataset.expand === 'true';

    if (!this.enabled) return;

    this.onResize();

    window.addEventListener('scroll', this.onScroll, {
      passive: true
    });

    window.addEventListener('resize', this.onResize);

    requestAnimationFrame(() => {
      this.onScroll();
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    this.sectionTop =
      this.getBoundingClientRect().top + window.scrollY;

    this.sectionHeight = this.offsetHeight;
    this.viewportHeight = window.innerHeight;
  }

  onScroll() {
    const scrollY = window.scrollY;

    const start = this.sectionTop;

    const end =
      this.sectionTop +
      this.sectionHeight -
      this.viewportHeight;

    let progress =
      (scrollY - start) /
      Math.max(end - start, 1);

    progress = Math.max(0, Math.min(progress, 1));

    const eased =
      1 - Math.pow(1 - progress, 3);

    const translateY =
      (1 - eased) * this.viewportHeight;

    this.content.style.transform =
      `translateY(${translateY}px)`;

    this.content.style.opacity = eased;

    if (progress > 0.1) {
      this.classList.add('entered');
    } else {
      this.classList.remove('entered');
    }

    if (progress > 0.95) {
      this.classList.add('reached');
    } else {
      this.classList.remove('reached');
    }
  }
}

customElements.define(
  'video-background',
  VideoBackground
);

// Product Testimonials
class ProductTestimonials extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSlider();
  }

  initSlider() {
    const slider = this.querySelector('.product-testimonials__slider');

    if (!slider) return;

    const prevButton = this.querySelector('.product-testimonials__arrow--prev');
    const nextButton = this.querySelector('.product-testimonials__arrow--next');
    const pagination = this.querySelector('.swiper-pagination');

    new Swiper(slider, {
      slidesPerView: 1.15,
      spaceBetween: 20,
      speed: 600,

      navigation: {
        prevEl: prevButton,
        nextEl: nextButton
      },

      pagination: {
        el: pagination,
        clickable: true
      },

      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 24
        }
      }
    });
  }
}

customElements.define('product-testimonials', ProductTestimonials);

// Product hero showcase
class ProductShowcaseHero extends HTMLElement {
  constructor() {
    super();

    this.heroSlider = this.querySelector('.product-showcase-hero__slider');
    this.productSlider = this.querySelector('.product-showcase-products');

    this.heroAutoplay = this.dataset.autoplay === 'true';
    this.heroAutoplaySpeed =
      Number(this.dataset.autoplaySpeed || 5) * 1000;

    this.productAutoplay =
      this.dataset.productAutoplay === 'true';

    this.productAutoplaySpeed =
      Number(this.dataset.productAutoplaySpeed || 3) * 1000;

    if (!this.heroSlider) return;

    this.init();
  }

  init() {
    this.initHeroSlider();
    this.initProductSlider();
  }

  initHeroSlider() {
    this.heroSwiper = new Swiper(this.heroSlider, {
      slidesPerView: 1,
      loop: true,
      speed: 1200,

      effect: 'fade',

      fadeEffect: {
        crossFade: false
      },

      autoplay: this.heroAutoplay
        ? {
            delay: this.heroAutoplaySpeed,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        : false,

      pagination: {
        el: this.querySelector('.product-showcase-hero__pagination'),
        clickable: true
      },

      navigation: {
        nextEl: this.querySelector('.product-showcase-hero__arrow--next'),
        prevEl: this.querySelector('.product-showcase-hero__arrow--prev')
      }
    });
  }

  initProductSlider() {
    if (!this.productSlider) return;

    this.productSwiper = new Swiper(this.productSlider, {
      slidesPerView: 'auto',
      loop: true,
      spaceBetween: 16,
      speed: 800,

      autoplay: this.productAutoplay
        ? {
            delay: this.productAutoplaySpeed,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        : false,

      breakpoints: {
        0: {
          spaceBetween: 12
        },
        768: {
          spaceBetween: 16
        }
      }
    });
  }

  handleSlideAnimation(swiper) {
    swiper.slides.forEach((slide) => {
      slide.classList.remove('is-current');
    });

    const activeSlide =
      swiper.slides[swiper.activeIndex];

    if (activeSlide) {
      activeSlide.classList.add('is-current');
    }
  }
}

customElements.define(
  'product-showcase-hero',
  ProductShowcaseHero
);